/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   * Вид для звездочек рейтинга в карточке товара и в товарах каталога, поиска, корзины
   */
  app.StarRatingView = app.View.extend({
    additionalOptions: ['rating', 'counter', 'onRatingClick', 'isNewMobileProductPage'],
    el: '',
    events: {},
    run: function (options) {
      this.ratingTemplate = app.helpers.TemplateHelper.getTemplate('#product-rating-template');
      if (app.isMobile && this.isNewMobileProductPage) {
        this.ratingTemplate = app.helpers.TemplateHelper.getTemplate('#mobile-product-rating-template');
      }
      this.render();
    },

    /**
     * Рисуем звезды рейтинга
     * @param rating
     * @param counter
     */
    render: function (rating, counter) {
      rating = rating || this.rating;
      counter = counter || this.counter;
      if (rating && (app.locale === app.LOCALES.ru || app.isMobile)) {
        this.$el
          .html(this.getStarRatingMarkup(rating, counter))
          .removeClass('not_display');
      }
      if (this.onRatingClick) {
        this.delegateEvents({
          'click .reviews-counter': this.onRatingClick
        });
      }
    },

    /**
     * Получаем разметку из шаблона звезд
     * @param rating
     * @param counter
     * @returns {*}
     */
    getStarRatingMarkup: function (rating, counter) {
      return this.ratingTemplate({
        stars: this.getStarsArray(rating),
        number: counter,
        declinationHelper: app.helpers.DeclinationHelper,
      });
    },

    /**
     * Собираем массив звезд из числа рейтинга
     * 2.5 -> ['full', 'full', 'half', 'empty', 'empty']
     * @param rating number
     * @returns {*}
     */
    getStarsArray: function (rating) {
      if (!rating) {
        return null;
      }

      var full = Math.floor(rating),
        empty = Math.floor(5 - rating),
        half = 5 - full - empty,
        stars = [];

      for (var i = 0; i < full; i++) {
        if (half == 0 && i == (full - 1)) {
          stars.push('full big');
        } else {
          stars.push('full');
        }
      }
      for (i = 0; i < half; i++) {
        stars.push('half');
      }
      for (i = 0; i < empty; i++) {
        stars.push('empty');
      }

      return stars;
    }

  });
})(jQuery);


}.call(window));